module.exports = __webpack_public_path__ + "static/media/icon_158.9a22ac85.svg";